module.exports = __webpack_public_path__ + "static/media/cabinet-filing.3130fbba.svg";